import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppHands from '../../assets/icons/app_hands.svg';
import OnboardingBackground from '../../components/OnboardingBackground';
import OnboardingCardTemplate from '../../components/OnboardingCardTemplate';
import { useAmplitude } from '../../providers/AmplitudeProvider';
import { ILink } from '../../services/link/types';
import { onWebAppMagicAuthLinkLoaded } from '../../tracking/trackers';
import AuthService from '../../services/auth/service';
import { useAuth } from '../../providers/AuthProvider';
import { useQuery } from '../../util/hooks';

const MagicAuthLinkType = ({
    linkToken,
    tokenData,
}: {
    linkToken: string;
    tokenData: ILink;
}) => {
    const navigate = useNavigate();
    const { isInitialized } = useAmplitude();
    const { setToken } = useAuth();
    const query = useQuery();
    const path = query.get('path');

    useEffect(() => {
        if (isInitialized) {
            onWebAppMagicAuthLinkLoaded({
                magic_auth_token: linkToken,
            });
        }
    }, [isInitialized]);

    useEffect(() => {
        AuthService.getMagicAuthToken(tokenData?.slug!).then((response) => {
            // @ts-ignore
            const authToken = response?.data?.auth_token;
            setToken(authToken);
            if (path) {
                navigate(path);
            } else {
                navigate('/');
            }
        });
    }, []);

    return (
        <>
            <OnboardingBackground>
                <OnboardingCardTemplate
                    title={'Connecting you to your account...'}
                    content={
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <img
                                    src={AppHands}
                                    alt=""
                                    width={150}
                                    height={150}
                                    style={{ marginTop: 30 }}
                                />
                            </div>
                        </>
                    }
                />
            </OnboardingBackground>
        </>
    );
};

export default MagicAuthLinkType;
